import { useTheme } from '@mui/material';

export const NewStudyIcon = () => {
    const theme = useTheme();
    const { stroke } = theme.colors.other.icon;

    return (
        <svg width={49} height={48} xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.375 34V28.4937C10.375 28.3312 10.3937 28.1688 10.4375 28.0063V28H16.7563L18.2063 30.8937C18.5437 31.5687 19.2375 32 19.9937 32H28.7563C29.5125 32 30.2063 31.575 30.5438 30.8937L31.9937 28H38.3125V28.0063C38.35 28.1625 38.375 28.325 38.375 28.4937V34C38.375 35.1063 37.4813 36 36.375 36H12.375C11.2687 36 10.375 35.1063 10.375 34ZM37.8125 26H31.9937C31.2375 26 30.5437 26.425 30.2062 27.1063L28.7563 30H19.9937L18.5437 27.1063C18.2063 26.4313 17.5125 26 16.7563 26H10.9375L14.0563 13.5125C14.2812 12.625 15.0813 12 16 12H32.75C33.6688 12 34.4688 12.625 34.6875 13.5125L37.8125 26ZM8.375 28.4937V34C8.375 36.2062 10.1688 38 12.375 38H36.375C38.5812 38 40.375 36.2062 40.375 34V28.4937C40.375 28.1687 40.3375 27.8438 40.2563 27.525L36.6313 13.0312C36.1875 11.25 34.5875 10 32.75 10H16C14.1625 10 12.5625 11.25 12.1188 13.0312L8.49375 27.525C8.4125 27.8375 8.375 28.1625 8.375 28.4937Z"
                fill={stroke.primary}
            />
        </svg>
    );
};
